<div class="pef" id="pefDashboard">
  @if (loading) {
    <mds-loader></mds-loader>
  }
  @if (!loading) {
    @if (data) {
      <article class="pef__header">
        <p>PEF Analysis of</p>
        <h1>{{ data.name }}</h1>
        <p>
          Calculations based method:
          <span>{{ this.selectedPcr.calculation_method }}</span>
        </p>
        <div class="pef__status">
          <mds-chip
            [showChipIcon]="true"
            [icon]="icons.TICK_CALENDAR"
            [label]="'Declaration Unit ' + this.selectedPcr.functional_unit"
            [removable]="false"
            [theme]="'light'"
          ></mds-chip>
          <mds-chip
            [showChipIcon]="true"
            [icon]="icons.RELOAD"
            [label]="'Updated On ' + (this.selectedPcr.updated_date | ordinalDate)"
            [removable]="false"
            [theme]="'light'"
          ></mds-chip>
        </div>
        <div class="pef__selections">
          <mds-dropdown-menu
            [multiple]="false"
            [checkbox]="false"
            [toggle]="false"
            [showClear]="false"
            [showSearch]="false"
            [showBadge]="false"
            [showArrows]="true"
            [disabled]="false"
            [helperTextPre]="'PCR'"
            [text]="selectedPcr.pcr"
            [options]="pcrList"
            [selectedValue]="selectedPcr.pcr"
            (selectedValueChange)="onChangePcr($event)"
          ></mds-dropdown-menu>
          <mds-button
            [size]="'medium'"
            [type]="'secondary'"
            [icon]="icons.FILE_DOWNLOAD"
            [isIconLeft]="true"
            [aria-label]="'docx'"
            (click)="export('docx')"
            [disabled]="isExporting"
            >
            Export to Word
          </mds-button>
          <mds-button
            [size]="'medium'"
            [type]="'primary'"
            [icon]="icons.DOWNLOAD"
            [disabled]="isExporting"
            [isIconLeft]="true"
            [aria-label]="'pdf'"
            (click)="export('pdf')"
            >
            Export to PDF
          </mds-button>
        </div>
      </article>
    }
    @if (selectedPcr.total) {
      <article class="pef__score">
        <h3>
          <mds-icon [key]="icons.ENVIRONMENT_CONTAINER" [width]="42" [height]="42" [pathColors]="['#339095']"></mds-icon>
          PEF Impact assessment
        </h3>
        <div class="pef__score-box">
          <div class="pef__score-card">
            <app-pef-score [score]="selectedPcr['total']"></app-pef-score>
          </div>
          <div class="pef__score-grid">
            @if (selectedPcr.error) {
              <ng-container *ngTemplateOutlet="errorTemplate; context: { message: selectedPcr.error }"></ng-container>
            } @else {
              <div id="pef-score-grid">
                <mds-grid
                  [overrides]="overrides"
                  [minHeight]="'300px'"
                  [sizeColumnsToFit]="true"
                  [themeClass]="'ag-theme-material'"
                  (gridReady)="onGridReady($event)"
                ></mds-grid>
              </div>
              @if (selectedPcr.scores?.length) {
                <div class="pef__score-footnote">
                  <mds-button
                    [size]="'small'"
                    [type]="'tertiary'"
                    [icon]="footnoteButtonIcon"
                    [isIconLeft]="true"
                    [isIconRight]="true"
                    [isLeftRightIconSame]="true"
                    [aria-label]="'Show footnote'"
                    class="footnote-button"
                    (click)="footnoteToggle()"
                    #footnoteButton
                    >
                    <span id="showMoreImpact">Show footnote</span>
                  </mds-button>
                  @if (!isFootnoteCollapse) {
                    <div>
                      @for (item of selectedPcr.scores; track item; let i = $index) {
                        <p>{{ i + 1 }}). &nbsp; {{ item.category }}</p>
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
      </article>
    }
    <article class="pef__chart">
      <app-gwp-chart [rid]="rid"></app-gwp-chart>
    </article>
    <article class="pef__scenario-analysis">
      <h3>
        <mds-icon [key]="icons.SCENARIO" [width]="42" [height]="42"></mds-icon>
        Scenario analysis
      </h3>
      @if (selectedPcr.error) {
        <ng-container *ngTemplateOutlet="errorTemplate; context: { message: selectedPcr.error }"></ng-container>
      } @else {
        @if (scoreLoading) {
          <mds-loader></mds-loader>
        }
        @if (!scoreLoading) {
          <div>
            <app-scores-compare
              [data]="comparisonData"
              (configureAlternatives)="configureAlternatives($event)"
            ></app-scores-compare>
          </div>
          <div>
            <app-score-compare-table
              [data]="comparisonData"
              (scenarioAgGridEmit)="scenarioAgGridEmit($event)"
            ></app-score-compare-table>
          </div>
        }
      }
    </article>
    <div class="pef__footer-export">
      <mds-button
        [disabled]="isExporting"
        [size]="'medium'"
        [type]="'secondary'"
        [icon]="icons.FILE_DOWNLOAD"
        [isIconLeft]="true"
        [aria-label]="'docx'"
        (click)="export('docx')"
        >
        Export to Word
      </mds-button>
      <mds-button
        [disabled]="isExporting"
        [size]="'medium'"
        [type]="'primary'"
        [icon]="icons.DOWNLOAD"
        [isIconLeft]="true"
        [aria-label]="'pdf'"
        (click)="export('pdf')"
        >
        Export to PDF
      </mds-button>
    </div>
  }
</div>

<ng-template #errorTemplate let-message="message">
  <mds-alert type="error" [text]="message"></mds-alert>
</ng-template>
